export const OVERAGES_ENABLED =
  'Your account is automatically upgraded to the next level of credits to make sure there are no ' +
  'interruptions to your messaging service.';
